import { SkipForward } from 'lucide-react';
import { Label } from '../../../../../components/ui/label';
import { Switch } from '../../../../../components/ui/switch';
import { useAnalytics } from '../../../../../core/analytics/useAnalytics';
import { useAppStore } from '../../../../../store/appStore';

/**
 * Settings → Sessions → "On startup": the reversible home of the
 * "Always start a new session" escape hatch also offered on the startup
 * Sessions dialog itself. Same persisted `startupSessionBehavior` field.
 */
export function StartupSessionSection() {
  const startupSessionBehavior = useAppStore((state) => state.startupSessionBehavior);
  const setStartupSessionBehavior = useAppStore((state) => state.setStartupSessionBehavior);
  const { track } = useAnalytics();

  return (
    <div className="space-y-3">
      <div className="text-sm font-medium">On Startup</div>

      <div className="flex items-center justify-between rounded-md border border-border bg-background p-4">
        <div className="flex items-center gap-3">
          <SkipForward className="h-5 w-5 text-muted-foreground" />
          <div className="grid gap-0.5">
            <Label htmlFor="always-start-new-session-setting" className="cursor-pointer">
              Always start a new session
            </Label>
            <div className="text-xs text-muted-foreground">
              Skip the &ldquo;Resume Last Session&rdquo; dialog and land on the Start Page.
              Previous sessions stay available from the toolbar Sessions button.
            </div>
          </div>
        </div>
        <Switch
          id="always-start-new-session-setting"
          checked={startupSessionBehavior === 'new-session'}
          onCheckedChange={(checked) => {
            setStartupSessionBehavior(checked ? 'new-session' : 'ask');
            track('feature:sessions_always_start_new_toggled', {
              enabled: checked,
              via: 'settings',
            });
          }}
          data-testid="always-start-new-session-toggle"
        />
      </div>
    </div>
  );
}
